export const menuEn = {
  logoutConfirm: 'Exit from the account?',
  openMenuHint: 'Open menu',
  hideMenuHint: 'Hide main menu',

  profileHint: 'Profile',
  myTasksHint: 'My tasks',
  othersTasksHint: "Other people's tasks",
  myCompanyHint: 'My company',
  chatsHint: 'Chats',
  eventsListHint: 'Event list',
  statisticsHint: 'Reports',
  billingHint: 'License and payment',
  partnerHint: 'Partners',
  supportPage: 'Support, News',
  projectsCaption: 'Projects',
  chatsCaption: 'Chats',
  companiesCaption: 'Companies',
  companiesSettings: 'Companies Settings',
  newPendingRegistrationsHint: 'New pending registration requests'
}

export const menuRu: typeof menuEn = {
  logoutConfirm: 'Выйти из аккаунта?',
  openMenuHint: 'Развернуть меню',
  hideMenuHint: 'Свернуть меню',

  profileHint: 'Мой профиль',
  myTasksHint: 'Мои задачи',
  othersTasksHint: 'Чужие задачи',
  myCompanyHint: 'Моя компания',
  chatsHint: 'Личные чаты',
  eventsListHint: 'Лента событий',
  statisticsHint: 'Отчеты',
  billingHint: 'Лицензия и оплаты',
  partnerHint: 'Партнерам',
  supportPage: 'Поддержка, Новости',
  projectsCaption: 'Моя компания',
  chatsCaption: 'Чаты',
  companiesCaption: 'Компании',
  companiesSettings: 'Настройка компаний',
  newPendingRegistrationsHint: 'Есть новые запросы на регистрацию'
}
